import {Box,Table,Thead,Tbody,Tr,Th,Td,TableContainer,  Text, Center, Spacer,Menu,MenuButton,MenuList,Button,
    MenuItem,IconButton,Divider,Switch,Tooltip,DrawerOverlay,DrawerContent,DrawerHeader,DrawerBody, Drawer,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay
    
} from '@chakra-ui/react'
import { loggedOper as lp } from '../../util/grunt';
import {useState,useEffect } from 'react'
import GruntPager from '../custom/GruntPager';
import { HamburgerIcon,EditIcon,WarningIcon,WarningTwoIcon,DeleteIcon } from '@chakra-ui/icons';
import PopisGovedaDetailTableHeader from './PopisGovedaDetailTableHeader';
import PopisiGovedaItemDetails from './PopisGovedoItemDetails';

export default function PopisGovedaDetailTable({goveda,isGeneratingReport=false,isGeneratingSpec=false,onGetReportExcel,onUpdateGovedoInRgg,
    onUkljuciUIspisChanged,tableSize='xs',readonly=false,onSavePopisGovedo,onCreateSpec,onDeletePopis,onDeletePopisGovedo}) {
    const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:22,currpage:1,govedaprikaz:[]});
    const [popisgovedoidforedit,setPopisGovedoIdForEdit]=useState(0)
    const [delid,setDelId]=useState(0)
    const [popisisdeleting,setPopisIsDeleting]=useState(false);
    const userCanEdit=lp.uloga==="r"?false:true;
    const isReadonly=userCanEdit===false || readonly ?true:false;
    const isReadOnlyHeader=!userCanEdit || readonly;

    
    

    useEffect(() => {
      setPrikaz({...prikaz,govedaprikaz:goveda})
    }, [goveda])
    

    const handleDeleteGovedo=()=>{
        
        onDeletePopisGovedo(delid);
        setDelId(0)
    }

    const handleFilter=(e)=>{
        
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        //let _test=false;
        
        let _ar=goveda.filter((item)=>{
            return _r.test(item.zivbr) || _val0==="";
        })
        
            setPrikaz({...prikaz,currpage:1,govedaprikaz:_ar})
        
        
        
    }

    
    const getDeleteDialog=()=>{
        if (delid!==0) {
            return (
                <>
                    <AlertDialog isOpen>
                        <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Uklanjanje goveda s popisa
                            </AlertDialogHeader>
                
                            <AlertDialogBody>
                            Jeste li sigurni da želite obrisati govedo s popisa?
                            </AlertDialogBody>
                
                            <AlertDialogFooter>
                            <Button onClick={()=>setDelId("")} colorScheme="grunt2" variant={'outline'}>
                                Odustani
                            </Button>
                            <Button colorScheme='red' variant={'outline'} onClick={handleDeleteGovedo} ml={3}>
                                Obriši
                            </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                        </AlertDialogOverlay>
                    </AlertDialog>
                </>
            )    
        }
        
    }

    const ShowGruntPager=()=>{
        if (prikaz.govedaprikaz.length>0) {
            return (
                <GruntPager currpage={prikaz.currpage} rowcount={prikaz.govedaprikaz.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }
    const ukljucenoUPopisChanged=(id,ukljuci)=>{
        
        onUkljuciUIspisChanged(id,ukljuci);
    }
    const getSpolForDisplay=(x)=>{
        if (x.toLowerCase()==="m") {
            return "M";
        } else {
            return "Ž";
        }
    }
    const getIcon=(govedopopis)=>{
        const govid=govedopopis.govedo_id;
        const govmigrid=govedopopis.govedo_migracija_id;
       // let _res;
        if (govid===0) {//govedo nikad nije bilo u registru
            return (
                <Tooltip label={'Grlo ne postoji u registru.'}>
                    <WarningIcon color={'red.500'}/>
                </Tooltip>
            )
        } else if (govid!==0 && govmigrid===0) {//govedo zavedeno da je otišli sa farme
            return (
                <Tooltip label={'Govedo je napustilo farmu.'}>
                    <WarningTwoIcon color={'red.500'}/>
                </Tooltip>
            )
        } else if (govid!==0 && govmigrid!==0) {//tu je sve ok
            return (<></>)
        }
    }
  
const getSpecifikacijaOpis=()=>{
    let _res=null;
    if (goveda[0].specifikacija_id!==0) {
        
        _res=<>
            <Text fontSize={'sm'}>Specifikacija:</Text>
            <Text ml={'1rem'} fontSize={'sm'} fontWeight={'semibold'}>{goveda[0].specifikacija_id}</Text>
            <Text ml={'3rem'} fontSize={'sm'}>Datum:</Text>
            <Text ml={'1rem'} fontSize={'sm'} fontWeight={'semibold'}>{new Date(goveda[0].specifikacija_datum.split('T')[0]).toLocaleDateString('HR-hr')}</Text>
        </>
    }
    return _res;
}

const handleDeletePopis=()=>{
    setPopisIsDeleting(true);
    onDeletePopis()
}
    const showGoveda=()=>{
        
        return (
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <PopisGovedaDetailTableHeader onFilterChange={handleFilter} isDeleting={popisisdeleting} onDelete={handleDeletePopis} specopis={getSpecifikacijaOpis()} readonly={isReadOnlyHeader} isGeneratingSpec={isGeneratingSpec} isGeneratingReport={isGeneratingReport} onGetExcelReport={onGetReportExcel} onCreateSpecification={onCreateSpec}/>
                <TableContainer >
                    <Table variant={'unstyled'} size={tableSize}>
                        <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                            <Tr>
                                <Th w={'1%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                <Th w={'1%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr.</Th>
                                <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Živ. br.</Th>
                                <Th w={'12%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rfid</Th>
                                <Th w={'3%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Komentar</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Boks</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                                <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Može na specif.</Th>
                                
                            </Tr>
                        </Thead>
                        <Tbody>
                        {prikaz.govedaprikaz.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                            
                            
                             return (
                                <Tr  color={'grunt2'} key={item.migracija_id}  bg={'white'} fontWeight={'normal'} 
                                _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                                    <Td textAlign={'center'} fontSize={tableSize}>
                                        <Menu size={tableSize} zIndex={1}>
                                                        <MenuButton
                                                            as={IconButton}
                                                            aria-label='Options'
                                                            icon={<HamburgerIcon />}
                                                            variant={'outline'} size={tableSize}
                                                            
                                                        />
                                                        <MenuList>
                                                            
                                                            <MenuItem size={tableSize} icon={<EditIcon boxSize={'14px'} />} onClick={()=>setPopisGovedoIdForEdit(item.id)}>Uredi</MenuItem>
                                                            <Divider/>
                                                            <MenuItem isDisabled={isReadonly} size={tableSize} icon={<DeleteIcon boxSize={'14px'} color={'red.700'}/>} onClick={()=>setDelId(item.id)}>Briši</MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                        </Td>
                                        <Td fontSize={tableSize}>
                                        {
                                           getIcon(item)
                                        }
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        {`${(i+1)+((prikaz.currpage-1)*prikaz.rowsperpage)}.`}
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.zivbr}</Td>
                                    <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>
                                        {
                                            item.rfid!==item.rfid_baza && item.govedo_id!==0?
                                            <Tooltip label={`RFID u registru je različit od dostavljenog.`}>
                                                <Text color={'red.500'} fontWeight={'semibold'}>{item.rfid}</Text>
                                            </Tooltip>:
                                            <Text>{item.rfid}</Text>
                                        }
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                            {
                                                item.spol!==item.spol_baza && item.spol_baza!==""?
                                                <Tooltip label={`Spol u registru je ${getSpolForDisplay(item.spol_baza)}.`}>
                                                    <Text color={'red.500'} fontWeight={'semibold'}>{getSpolForDisplay(item.spol)}</Text>
                                                </Tooltip>:
                                                <Text>{getSpolForDisplay(item.spol)}</Text>
                                            }
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                            {
                                                item.pasmina_sifra!==item.pasmina_sifra_baza && item.govedo_id!==0?
                                                <Tooltip label={`Pasmina u registru je ${item.pasmina_baza}.`}>
                                                    <Text color={'red.500'} fontWeight={'semibold'}>{item.pasmina}</Text>
                                                </Tooltip>:
                                                item.pasmina
                                            }
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        <Tooltip label={item.komentar}>
                                            {item.komentar.length>30?item.komentar.substring(0,27)+'...':item.komentar}
                                        </Tooltip>
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        {item.boks_id!==item.boks_id_baza && item.govedo_id!==0?
                                            <Tooltip label={`Lokacija u registru razlikuje se od prijavljene.`}>
                                                <Box display={'flex'} flexDir={'column'} color={'red.500'}>
                                                    <Text fontSize={'10px'}>{item.lokacija} / {item.toviliste}</Text>
                                                    <Text fontWeight={'bold'} fontSize={'10px'}>{item.odjeljak}</Text>
                                                </Box>
                                            </Tooltip>:
                                            <Box display={'flex'} flexDir={'column'}>
                                            <Text fontSize={'10px'}>{item.lokacija} / {item.toviliste}</Text>
                                            <Text fontWeight={'bold'} fontSize={'10px'}>{item.odjeljak}</Text>
                                        </Box>
                                        }
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        {item.knjiga}
                                    </Td>
                                    <Td fontSize={tableSize} textAlign={'center'}>
                                        
                                        <Switch isDisabled={readonly} colorScheme={'grunt2'} size={'sm'} isChecked={item.ukljuciupopis} onChange={(x,y)=>{ukljucenoUPopisChanged(item.id,!item.ukljuciupopis)}}/>
                                    </Td>
                                    
                                    
                                </Tr>
                             )
                        })}
                        </Tbody>
                        </Table>
                </TableContainer>
                {editGovedo()}
                {getDeleteDialog()}
        </Box>
        )    

    
}
const getFooter=()=>{
    return (
        
        <Box flexDir={'row'} display={'flex'} w="100%" alignItems={'center'} h={'40px'}>
            
            <Box w="25%">
                {showBrZapis()}
            </Box>
            <Box w="50%">
                <Center>
                    {ShowGruntPager()}
                </Center>
            </Box>
            <Box w="25%">
                
            </Box>
        </Box>
        
    )
  }
  const showBrZapis=()=>{
    return (
      <Text fontSize={'xs'}>Prikazano zapisa: {prikaz.govedaprikaz.length}</Text>
    )
  }



const editGovedo=()=>{
    if (popisgovedoidforedit!==0) {
        return (
            <Drawer placement='right' size={'lg'} isOpen={true}>
                <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        Izmjena podataka
                    </DrawerHeader>
                    <DrawerBody>
                        <PopisiGovedaItemDetails popisgovedoid={popisgovedoidforedit} onCancel={()=>setPopisGovedoIdForEdit(0)}
                         onSave={(a,b,c,d,e,f,g,h,i)=>{onSavePopisGovedo(a,b,c,d,e,f,g,h,i);setPopisGovedoIdForEdit(0)}}
                         onSaveAndUpdateRgg={(a,b,c,d,e,f,g,h,i)=>{onUpdateGovedoInRgg(a,b,c,d,e,f,g,h,i);setPopisGovedoIdForEdit(0)}}
                         isReadOnly={goveda[0].specifikacija_id!==0}
                         />              
                    </DrawerBody>
                </DrawerContent>
                </Drawer>
            )
    }
        
}

return (
<Box display={'flex'} flexDir={'column'} flex={1} w={'100%'}>
    
    {showGoveda()}
   
    <Spacer/>
    {getFooter()}
</Box>
)


}